import {dynamic} from '@github-ui/dynamic'
import {withLazyAppBoundary} from '@github-ui/react-core/lazy-app-boundary'

import type {CommitsRouteComponents} from './create-commits-routes'

export const lazyCommitsRouteComponents: CommitsRouteComponents = {
  CommitsLayout: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CommitsLayout}
    }),
  ),
  CommitsEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CommitsEntrypoint}
    }),
  ),
  CommitsRefEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CommitsRefEntrypoint}
    }),
  ),
  CommitEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CommitEntrypoint}
    }),
  ),
  CommitPathEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CommitPathEntrypoint}
    }),
  ),
}
